import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '0.25rem 0.75rem',
    borderRadius: '0.75rem',
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    width: 'fit-content',
  },
}))

export { useStyles }
